const getters = {
  typeset: state => state.gradeAnalysis.nowTypeSet,
  examid: state => state.gradeAnalysis.nowExamid,
  auth: state => state.lessonManage.auth,
  btnPermis: state => state.gradeAnalysis.btnPermis,
}
export default getters
